module.exports = __webpack_public_path__ + "static/media/1007130.c238e839.jpg";